import { Sidebar } from 'primereact/sidebar';
import React, { useEffect, useState } from 'react';
import './MobileMenu.scss';
import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PROJECTS } from '../../../routes/path';
import Panel from '../panel/Panel';
import useIsMobile from '../../../hooks/global/UseIsMobile';

// Sloty na treść bieżącej strony — wypełnia je `MobilePageHeader` (portal).
export const MOBILE_HEADER_TITLE_ID = 'mobile-header-title';
export const MOBILE_HEADER_ACTIONS_ID = 'mobile-header-actions';

/**
 * Górny pasek wersji mobilnej: menu, logo i akcje bieżącej strony. Strona z własnym tytułem
 * (np. dashboard projektu) zastępuje nim logo.
 * Menu wysuwa się z lewej i jest TYM SAMYM panelem co na desktopie (projekt, kategorie, narzędzia,
 * konto) — dzięki temu pozycje, uprawnienia i addony nie mają osobnej, mobilnej kopii.
 */
const MobileMenu = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const location = useLocation();
  const isMobile = useIsMobile();

  // Przejście na inną stronę (klik w pozycję menu) zamyka menu.
  useEffect(() => {
    setVisible(false);
  }, [location.pathname]);

  // Znacznik dla stylów panelu: w szufladzie ma być szeroki, choć ekran jest węższy niż próg railu
  // (patrz `panel-rail.scss`). Zdejmowany dopiero po wyjeździe szuflady (`onExited`) — zdjęty od razu
  // przełączałby panel w rail w trakcie animacji i treść zwijałaby się na oczach.
  useEffect(() => {
    if (visible) {
      document.documentElement.setAttribute('data-mobile-drawer', 'open');
    }
  }, [visible]);
  useEffect(() => () => document.documentElement.removeAttribute('data-mobile-drawer'), []);

  // Poszerzenie okna z otwartą szufladą: zamykamy ją od razu, bez czekania na animację — inaczej znacznik
  // zostałby na `<html>` i wyłączył rail desktopowego panelu.
  useEffect(() => {
    if (!isMobile) {
      setVisible(false);
      document.documentElement.removeAttribute('data-mobile-drawer');
    }
  }, [isMobile]);

  return (
    <>
      <Sidebar
        visible={visible}
        onHide={() => setVisible(false)}
        position="left"
        showCloseIcon={false}
        className="mobile-sidebar"
        maskClassName="mobile-sidebar-mask"
        transitionOptions={{
          classNames: 'mobile-sidebar-slide',
          timeout: 250,
          onExited: () => document.documentElement.removeAttribute('data-mobile-drawer'),
        }}
      >
        <button type="button" className="mobile-sidebar__close" onClick={() => setVisible(false)} aria-label={t('close')}>
          <span className="mobile-sidebar__close-icon" />
        </button>
        <Panel />
      </Sidebar>

      <div className="mobile-header">
        <button type="button" className="mobile-header__menu" onClick={() => setVisible(true)} aria-label="Open menu">
          <span />
        </button>
        <NavLink to={PROJECTS} className="logo mobile-header__logo">
          <div className="logo-box" />
        </NavLink>
        <div id={MOBILE_HEADER_TITLE_ID} className="mobile-header__title" />
        <div className="mobile-header__end">
          <div id={MOBILE_HEADER_ACTIONS_ID} className="mobile-header__actions" />
        </div>
      </div>
    </>
  );
};

export default MobileMenu;
